<template>
  <b-modal size="md" button-size="sm" hide-footer v-model="showModal" @hidden="cancelar" :title="title">
    <b-form @submit.prevent="save">
      <b-card>
        <b-form-row>
          <lg-form-input invalidFeedback="Informe uma descrição válida!" description=" " :error="$v.form.descricao"
            v-model="form.descricao" label="Descrição: *" cols="12" />
          <div class="d-flex align-items-center col-12">
            <label class="mr-2 text-reset">Status: *</label>
            <b-form-radio-group size="sm" v-model="form.situacao" :options="options" name="situacao-options"
              class="d-flex">
            </b-form-radio-group>
          </div>
        </b-form-row>
        <div class="d-flex justify-content-center mt-3" >
          <b-button id="salvarMarca" type="submit" variant="success" style="height: 30px" pill size="sm">
            <div class="btn-size-alinhamento">
              <b-icon icon="check-circle" />
            </div>
            <b-tooltip target="salvarMarca" title="Salvar" triggers="hover"></b-tooltip>

          </b-button>
          <b-button id="cancelarMarca" class="ml-2" @click="cancelar" style="height: 30px" pill size="sm" variant="danger">
            <div class="btn-size-alinhamento">
              <b-icon icon="x-circle" />
            </div>
            <b-tooltip target="cancelarMarca" title="Cancelar" triggers="hover"></b-tooltip>

          </b-button>
        </div>
      </b-card>
    </b-form>
  </b-modal>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import ResourceService from "@/core/api/ResourceService";
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
  components: {
    LgFormInput,
  },
  mixins: [FormResourceMixin],
  validations: {
    form: {
      descricao: { required },
      situacao: { required },
    },
  },
  computed: {
    updatedPrefix() {
      return [...this.prefix, this.id == null ? "Cadastro" : "Alteração"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  props: {
    isModal: Boolean,
    id: Number,
    prefix: {
      type: Array,
      required: true,
    },
    empresaNome: String,
  },
  data() {
    return {
      options: [
        { text: "Ativo", value: "1" },
        { text: "Inativo", value: "0" },
      ],
      showModal: true,
      form: {
        descricao: "",
        situacao: 1,
      },
    };
  },
  async beforeMount() {
    this.$service = new ResourceService(`/api/marca`);
  },
  async mounted() {
    if (this.id) {
      const { data } = await this.$service.findById(this.id);
      this.form = data;
    } else {
      this.form.situacao = 1;
    }
  },
  methods: {
    cancelar() {
      this.$emit("close");
    },
    async save() {
      if (!this.formIsValid) {
        this.$v.$touch();
        this.$notify({
          type: "danger",
          message: "Verifique os campos do cadastro.",
        });
        return;
      }
      try {
        await this.$saveResource(
          this.form,
          "",
          true,
          {},
          this.isModal
        );
        this.cancelar();
      } catch (error) {
        this.$notify({
          type: "danger",
          message: `Erro ao salvar`,
        });
        console.error(error);
      }
    },
  },
};
</script>
